export const getFragment = (root,dataJsId) => root.querySelector(`[data-js='${dataJsId}']`);

export const renderIfTrue = (bool, fn) => {
    if(bool){
        return fn();
    }

    return "";
};